import tinymce from './components/TinymceVue'

export default tinymce
export { tinymce }